module.exports = require('./helpers/bundle-url').getBundleURL('hstjT') + "message-bubble-white.5cdd0a77.svg";